/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDlvryExportCartViewProps } from './dlvry-export-cart';

export default (props: IDlvryExportCartViewProps) => {
    const { heading, table } = props;

    return (
        <div className='dlvry-export-cart'>
            {heading}
            {table}
        </div>
    );
};
